var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0393677 32.0394C0.0393677 14.3954 14.3954 0.0393677 32.0394 0.0393677C49.6847 0.0393677 64.0394 14.3954 64.0394 32.0394C64.0394 49.6834 49.6834 64.0394 32.0394 64.0394C14.3954 64.0394 0.0393677 49.6834 0.0393677 32.0394ZM48.8867 26.276C49.9368 25.3795 50.0613 23.8015 49.1648 22.7515C48.2682 21.7014 46.6902 21.5769 45.6402 22.4734L26.3907 38.9081L21.0206 34.0276C19.9988 33.099 18.4177 33.1745 17.4891 34.1963C16.5605 35.2181 16.636 36.7992 17.6578 37.7278L24.6577 44.0895C25.5893 44.9361 27.0051 44.958 27.9624 44.1407L48.8867 26.276Z",
    fill: "#248647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.763b6ba1043a6f5b363c01d5ce98ae34.svg";
export { ForwardRef as ReactComponent };